import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import Badge, { BadgeProps } from '@material-ui/core/Badge';

const styles = (theme: Theme) =>
  createStyles({
    badge: {
      top: '85%',
      right: 6,
      minWidth: 0,
      width: 12,
      height: 12,
      border: `2px solid ${theme.palette.common.white}`,
      background: theme.custom.palette.colorAccentAloe,
    },
  });

export interface BadgeOnlineProps extends WithStyles<typeof styles>, Omit<BadgeProps, 'classes'> {}

const BadgeOnline: React.FC<BadgeOnlineProps> = ({ classes, ...rest }) => (
  <Badge classes={{ badge: classes.badge }} variant="dot" {...rest} />
);

export default withStyles(styles, { name: 'BadgeOnline' })(BadgeOnline);
